import React from 'react'
import OffersChoiceResult from "./OffersChoiceResult";

function Index(
    {
        expanded,
    }) {
    return (expanded && <OffersChoiceResult/>)
}


export default Index;